export const ActionTypes = {
  LOADING: "GET_CRITERIA_LOADING",
  ERROR: "GET_CRITERIA_ERROR",
  SUCCESS: "GET_CRITERIA_SUCCESS",
};
